import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { css } from "@emotion/react";
import { Listbox } from "@headlessui/react";
import { styled } from "../theme";
import { Text } from "../text";
/**
 * A customizable dropdown select component.
 *
 * @param {DropdownSelectProps<T>} props The props for the component.
 * @returns {JSX.Element} The rendered dropdown select component.
 */
export const DropdownSelect = ({ trigger, disabled, items, selectItem, selectedItem, label, className, }) => (_jsx(Listbox, { value: selectedItem, onChange: selectItem, children: _jsxs(Container, { className: className, children: [label && _jsx(Listbox.Label, { as: Label, children: label }), disabled ? (_jsx(TriggerWrapper, { "data-test-id": `dropdown-select-${label}`, children: trigger({ isOpened: false, selectedItem }) })) : (_jsx(Listbox.Button, { as: Fragment, children: ({ open }) => (_jsx(TriggerWrapper, { "data-test-id": `dropdown-select-${label}`, children: trigger({ isOpened: open, selectedItem }) })) })), _jsx(Listbox.Options, { as: DropdownSelectList, children: items.map((item, index) => (_jsx(Fragment, { children: item.type === "DIVIDER" ? (_jsx(Divider, {})) : (_jsx(Listbox.Option, { as: Fragment, value: item, "data-test-id": `dropdown-select-item-${item.id}`, children: ({ active }) => (_jsx(DropdownSelectOption, { active: active, children: item.label })) }, item.id)) }, index))) })] }) }));
DropdownSelect.defaultProps = {
    className: "",
    trigger: ({ selectedItem }) => selectedItem.label,
};
const Container = styled.div `
  display: inline-block;
  position: relative;
`;
const Label = styled(Text) `
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: 14px;
  line-height: 17px;
  margin-right: 6px;
`;
const TriggerWrapper = styled.div `
  display: inline-block;
  cursor: pointer;
`;
export const DropdownSelectList = styled.div `
  position: absolute;
  right: 0;
  background-color: ${({ theme }) => theme.color.white};
  margin-top: 10px;
  z-index: 100;
  white-space: nowrap;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);

  &:focus-visible {
    outline: none;
    box-shadow: 0px 0px 2px ${({ theme }) => theme.color.primary},
      0 2px 10px 0 rgba(0, 0, 0, 0.25);
  }
`;
export const DropdownSelectOption = styled.div `
  padding: 12px 16px;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  &:hover {
    background-color: ${({ theme }) => theme.color.darkBlue10};
  }

  ${({ active, theme }) => active &&
    css `
      background-color: ${theme.color.borderLightGray};
    `}
`;
const Divider = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.color.gray10};
`;
